import { useMemo, useRef } from 'react';

/**
 * Stable refs and memoized keys for ELK / graph identity (task graph + chain order).
 */
export function useFlowchartCoreRefsAndGraphKeys({ tasks, autoPositions, chainOrder, base }) {
  const { taskIdSignature, dependencySignature } = base;
  const tasksRef = useRef(tasks);
  tasksRef.current = tasks;
  const autoPositionsRef = useRef(autoPositions);
  autoPositionsRef.current = autoPositions;
  const chainOrderRef = useRef(chainOrder);
  chainOrderRef.current = chainOrder;

  const taskGraphKey = useMemo(
    () => `${taskIdSignature}|${dependencySignature}`,
    [taskIdSignature, dependencySignature],
  );
  const chainOrderKey = useMemo(
    () => (chainOrder && chainOrder.length ? chainOrder.join(',') : ''),
    [chainOrder],
  );

  return { tasksRef, autoPositionsRef, chainOrderRef, taskGraphKey, chainOrderKey };
}
